import React from 'react';
import { ProductCarousel } from '@hpstellar/core/visId';
import ProductTile from '../../../../../../product/components/product-tile';
import loadable from '@loadable/component';
import './related-products-offer.less';

const VisIDProductTileView = loadable(() => Helpers.retryFunc(() => import('../../../../../../product/components/visId/product-tile-view')));

export default ({ products, title='Offer also applies to:' }) => {

    return (
        <ProductCarousel title={title} className="product-offer-carousel" equalHeight infinite dots>
            {products.map(p => {
                return (
                    <div className="product-tile-offers">
                        <ProductTile
                            className=""
                            key={p.sku}
                            product={p}
                            visId={true}
                            offers={true}
                            analyticsData={{ list: 'plp' }}
                            ProductTileComponentProp={VisIDProductTileView}
                        />
                    </div>
                );
            })}
        </ProductCarousel>
    );
};
